import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './SelectDropdown.css';

const cx = classNames.bind(styles);

const titleCase = (name) => name.replace(/(^|\s)[a-z]/g, (letter) => letter.toUpperCase());

class SelectDropdown extends Component {
    static propTypes = {
        name: PropTypes.string,
        automationId: PropTypes.string,
        datasource: PropTypes.arrayOf(PropTypes.object).isRequired,
        defaultValueRequired: PropTypes.bool,
        hasPlaceholder: PropTypes.bool,
        overrideDefaultValue: PropTypes.bool,
        value: PropTypes.number,
        onChangeHandler: PropTypes.func,
        selectStyle: PropTypes.string,
        optionDisplayValue: PropTypes.string.isRequired,
        optionValue: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        theme: PropTypes.string,
        customFlag: PropTypes.bool,
        regularItem: PropTypes.bool,
        mtm: PropTypes.bool,
        fromMiniPDP: PropTypes.bool,
    };

    static defaultProps = {
        name: '',
        automationId: '',
        defaultValueRequired: false,
        hasPlaceholder: false,
        overrideDefaultValue: false,
        value: '0',
        onChangeHandler: null,
        selectStyle: null,
        disabled: false,
        theme: '',
        customFlag: false,
        regularItem: false,
        mtm: false,
        fromMiniPDP: false,
    };

    onChangeOptionHandler(e) {
        e.preventDefault();
        this.props.onChangeHandler(e.target.value);
    }

    renderDropdownOptions() {
        const { datasource, optionDisplayValue, optionValue } = this.props;
        let dropdownOptions = '';
        dropdownOptions = datasource.map((dataItem) => (
            <option value={dataItem[optionValue]} key={dataItem[optionValue]}>
                {dataItem[optionDisplayValue]}
            </option>
        ));
        return dropdownOptions;
    }

    renderDefaultOptions() {
        const {
            defaultValueRequired,
            hasPlaceholder,
            name,
            overrideDefaultValue,
            mtm,
        } = this.props;
        let defaultOptions = '';
        if (defaultValueRequired) {
            let label;
            if (name) {
                label = `Select a ${titleCase(name)}`;
            } else if (mtm) {
                label = 'Fraction';
            } else {
                label = 'Select';
            }
            if (overrideDefaultValue && name) {
                label = titleCase(name);
            }
            defaultOptions = (
                <option value={hasPlaceholder ? '' : name} disabled={hasPlaceholder}>
                    {label}
                </option>
            );
        }
        return defaultOptions;
    }

    renderSelectDropdown() {
        const { name, automationId, value, disabled, customFlag } = this.props;
        let className = null;
        if (customFlag) {
            className = dt(['text-gray-40', 'italic']);
        } else if (!value) {
            className = dt(['text-gray-60']);
        }
        const selectOptionStyle = dt([
            'pt-3',
            'pr-10',
            'pb-3',
            'pl-0',
            'w-[calc(100%-16px)]',
            'ml-4',
            'text-black',
            'font-open-sans-regular',
            'text-normal',
            'font-open-sans',
            'leading-5',
            'absolute',
            'min-w-full',
        ]);
        return (
            <select
                className={`${cx('selectOption')} ${className} ${selectOptionStyle}`}
                name={name}
                data-automation-id={automationId}
                value={value}
                disabled={disabled}
                onChange={(e) => this.onChangeOptionHandler(e)}
            >
                {this.renderDefaultOptions()}
                {this.renderDropdownOptions()}
            </select>
        );
    }

    render() {
        const { selectStyle, disabled, theme, customFlag, regularItem, fromMiniPDP } = this.props;
        const selectBlockStyle = dt([
            'block',
            'relative',
            'text-left',
            'border-gray-60',
            'rounded-lg',
            'bg-white',
            'border',
            'border-solid',
            'h-12',
            'smMd:w-full',
            'min-w-[80px]',
            'before:content-[""]',
            'before:border-l-[5px]',
            'before:border-l-transparent',
            'before:border-r-[5px]',
            'before:border-r-transparent',
            'before:border-t-[5px]',
            'before:border-black',
            'before:top-1/2',
            'before:right-5',
            'before:-translate-y-1/2',
            'before:absolute',
        ]);
        const className = selectBlockStyle;
        const miniPdpDdWidth = fromMiniPDP ? dt(['w-full']) : dt(['lg:w-1/2']);
        const isCustom = regularItem ? miniPdpDdWidth : '';
        let disableStyleClass = null;
        /* istanbul ignore next */
        if (disabled) {
            disableStyleClass = dt(['bg-gray-15', 'opacity-50', 'text-gray-40']);
            if (customFlag) {
                disableStyleClass = dt([
                    'bg-light-white',
                    'opacity-70',
                    'border',
                    'border-dashed',
                    'border-gray-60',
                    'text-gray-40',
                ]);
            }
        }

        return (
            <div
                data-automation-id="selectDropDownBlock"
                className={`${cx(className, isCustom, selectStyle, theme)} ${disableStyleClass}`}
            >
                {this.renderSelectDropdown()}
            </div>
        );
    }
}

export default SelectDropdown;
